import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/jobReasonReport'
import Component from 'components/Reports/JobReasonReport'

export default createListViewContainer({ actions, selectors: selectors.jobReasonReport })(Component)
